import { styled } from "../imports";
import Box from "./Box";
import { sizeProps, overflowProps } from "../props";
import { prop, spaceProp } from "../utils";
var TextColumns = /*#__PURE__*/styled(Box, {
  label: "TextColumns",
  target: "css-1y9y5ee0"
})(sizeProps, ";", overflowProps, ";", prop("columnCount", function (val, rawVal) {
  return "column-count:" + rawVal;
}), ";", prop("columnWidth", function (val) {
  return "column-width:" + val;
}), ";", prop("columnGap", function (val) {
  return "column-gap:" + val;
}), ";", spaceProp(function (val) {
  return "column-gap:" + val;
}), ";");
TextColumns.displayName = "TextColumns";
export default TextColumns;